<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@ds/lib/utils'

interface SkeletonProps {
  class?: HTMLAttributes['class']
}

const props = defineProps<SkeletonProps>()
</script>

<template>
  <div :class="cn('animate-pulse rounded-ds-md bg-muted', props.class)" />
</template>
